import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {
    CreateChildZone,
    CreateFatherZone,
    GetListStatusZone
} from "../../../../reduxToolkit/EmployeeZones/EmployeeZonesApi";
import ButtonIcon from "../../../../components/buttons/ButtonIcon";
import {CleanIcon} from "../../../../components/buttons/IconButtons";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 * A modal component for creating father or child zones with form inputs and validation.
 * @module AddZoneModalApp
 * @component
 * @param {Object} props - Component props.
 * @param {boolean} props.show - Controls modal visibility.
 * @param {Object|null} props.isFatherZone - Father zone data if creating child zone.
 * @param {string} props.check - Flag indicating zone type ('true' for child zone).
 * @param {Function} props.onHide - Callback for modal close event.
 * @returns {Object} Returns an object containing:
 * - Localization function `t`
 * - UI elements and handlers for form management
 * - State variables and setters for form fields
 */
export const AddZoneModalApp = (props) => {
    const {show, isFatherZone, check, onHide, setModified} = props;

    const {t} = useTranslation();
    // use hook importer
    const dispatch = useDispatch();
    const [emptyFields, setEmptyFields] = useState(false);

    //use Selector hook to get state for redux store
    const {getListStatusZone} = useSelector((state) => state.EmployeeZonesSlice);

    //use State hook for local state management
    const [name, setName] = useState('');
    const [isStatus, setIsStatus] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [searchLocation, setSearchLocation] = useState('');

    useEffect(() => {
        setName('');
        setIsStatus('');
        setLatitude('');
        setLongitude('');
        setSearchLocation('');
    }, [show]);

    useEffect(() => {
        if (show && 'geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;
                    setLatitude(lat);
                    setLongitude(lng);
                    sessionStorage.setItem('latitude', lat);
                    sessionStorage.setItem('longitude', lng);
                }
            );
        }
    }, [show]);

    const reset = () => {
        setIsStatus('');
        setLatitude('');
        setName('');
        setLongitude('');
        setSearchLocation('');
        setEmptyFields(false)
    };
    // a function to handel payload and dispatch api end function
    const handleCreateZone = () => {
        if (
            name !== '' &&
            isStatus !== '' &&
            latitude !== '' &&
            longitude !== ''
        ) {
            setEmptyFields(false);
        } else {
            setEmptyFields(true);
            return
        }

        // payload for father zone data
        const createFatherZoneFormData = {
            name,
            status: {
                id: isStatus,
            },
            latitud: Number(latitude),
            longitud: Number(longitude),
        };
        // payload for chilid zone data
        const createChildZoneFormData = {
            father: {
                id: isFatherZone?.id,
            },
            name,
            status: {
                id: isStatus,
            },
            latitud: Number(latitude),
            longitud: Number(longitude),
        };

        // condition to check  father zone or child zone
        if (check === 'true') {
            dispatch(CreateChildZone(createChildZoneFormData)).then(({payload:{data:{success}}})=>{
                if (success){
                    setModified(true)
                    reset();
                    props.onHide();
                }
            });
        } else {
            dispatch(CreateFatherZone(createFatherZoneFormData)).then(({payload:{data:{success}}})=>{
                if (success){
                    setModified(true)
                    reset();
                    props.onHide();
                }
            });
        }
    };
    const handleCleanClick = () => {
        setSearchLocation('');
    };
    // useEffect lifeCyle for dispatch list of status zone
    useEffect(() => {
        dispatch(GetListStatusZone());
    }, []);

    const clearButton = () => {
        return (
            <ButtonIcon
                id='btn_azm_clean'
                Icon={CleanIcon}
                onClick={reset}
                title={'clear_instances'}
                className={"btn-clean-secondary-600"}
                tooltipPlacement={"right"}
                iconProps='btn-icon-svg-12px icon-color-general-00'
            />
        )
    }

    const handleClose = () => {
        reset();
        onHide();
    };

    return {
        t,
        clearButton,
        handleCreateZone,
        searchLocation,
        setSearchLocation,
        handleCleanClick,
        name,
        setName,
        emptyFields,
        isStatus,
        setIsStatus,
        getListStatusZone,
        latitude,
        setLatitude,
        longitude,
        setLongitude,
        handleClose
    }

}
